// sanitizeKey.firestore.mjs
// Browser-safe, synchronous, Firestore-compatible

// Simple deterministic hash for fallback
function simpleHash(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // 32-bit integer
  }
  return (hash >>> 0).toString(16); // unsigned hex
}

/**
 * Sanitize string for use as Firestore document ID.
 * - Removes control chars
 * - Removes path traversal patterns (..)
 * - Converts / and \ to -
 * - Allows letters, numbers, underscores, dashes, dots, and spaces
 * - Collapses repeated dashes and spaces
 * - Trims leading/trailing spaces and dashes
 * - Enforces max length (default 100)
 * - Uses simple hash fallback if empty
 */
export function sanitize(input, opts = {}) {
  const maxLen = typeof opts.maxLen === 'number' ? opts.maxLen : 100;

  if (input === undefined || input === null) input = '';
  if (typeof input !== 'string') input = String(input);

  let s = input.normalize('NFC');

  // Remove control characters
  s = s.replace(/\p{C}/gu, '');

  // Remove path traversal dots
  s = s.replace(/\.\.+/g, '');

  // Convert path separators to dash
  s = s.replace(/[\/\\]+/g, '-');

  s = s.replace(/ /g, '_'); // optional: replace spaces with underscore

  // Only allow Firestore-safe chars + space
  s = s.replace(/[^A-Za-z0-9._\- ]+/g, '-');

  // Collapse repeated dashes and spaces
  s = s.replace(/-+/g, '-').replace(/ {2,}/g, ' ');

  // Trim leading/trailing dashes or spaces
  s = s.replace(/^-+|-+$/g, '').trim();

  // Enforce max length
  if (s.length > maxLen) s = s.slice(0, maxLen);

  // Fallback if string ends up empty
  if (s.length === 0) {
    const h = simpleHash(input).slice(0, 8);
    return `key-${h}`;
  }

  return s;
}

export default sanitize;
